<template>
    <v-container grid-list-lg>
        <h1 class="display-1 mb-1">
            Results
        </h1>
        <v-layout
            row
            wrap
        >
            <v-flex
                xs12
                sm8
            >
                <v-layout
                    row
                    wrap
                    mb-2
                >
                    <v-spacer />
                    <v-flex
                        xs6
                        md3
                    >
                        <v-btn
                            class="my-0"
                            flat
                            block
                            @click="onBack"
                        >
                            Back to Search
                        </v-btn>
                    </v-flex>
                    <v-flex
                        v-if="canEdit"
                        xs6
                        md3
                    >
                        <v-btn
                            class="my-0"
                            color="success"
                            block
                            @click="onEditClick"
                        >
                            <v-icon
                                left
                                size="20"
                            >
                                fas fa-edit
                            </v-icon>
                            Edit
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-card class="mb-3">
                    <v-card-title class="title">
                        {{ productReturn ? 'Product Return' : 'Invoice Products' }}
                    </v-card-title>
                    <v-divider />
                    <v-card-title
                        v-if="!productReturn"
                        class="justify-center"
                    >
                        <v-layout
                            row
                            wrap
                        >
                            <v-flex xs12>
                                <v-data-table
                                    :headers="headers"
                                    :items="invoice.products"
                                    hide-actions
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.itemNumber }}</td>
                                        <td>{{ props.item.description }}</td>
                                        <td class="shrink-column">
                                            {{ props.item.quantity }}
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-title
                        v-if="productReturn"
                    >
                        <return-info
                            :product-return="productReturn"
                        >
                            <template slot="footer">
                                <v-divider />
                                <v-btn
                                    class="my-3 mx-0"
                                    @click="onConfirmationClick"
                                >
                                    See Return Confirmation
                                </v-btn>
                            </template>
                        </return-info>
                    </v-card-title>
                    <v-card-actions
                        class="justify-center"
                    >
                        <v-btn
                            color="primary"
                            @click="onCreate"
                        >
                            Create Return
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex
                xs12
                sm4
            >
                <invoice-card :invoice="invoiceCardData" />
            </v-flex>
        </v-layout>
        <v-layout v-if="productReturn">
            <v-flex
                xs12
                sm8
            >
                <h2 class="headline mb-1">
                    Comments
                </h2>
                <comments
                    :comments="productReturn.comments"
                    :return-id="productReturn.uuid"
                    @refresh-data="onRefreshData"
                    :disabled="disableComments"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import InvoiceCard from '../../components/InvoiceCard'
import ReturnInfo from '../../components/ReturnInfo'
import Comments from '../../components/Comments'
import { OPEN, CLOSED } from '../../utils/constants/statuses'
import UserBus from '../../utils/buses/userBus'

const headers = [
    {
        text: 'Product #',
        sortable: false,
        value: 'itemNumber'
    },
    {
        text: 'Product Name',
        sortable: false,
        value: 'description'
    },
    {
        text: 'Quantity',
        sortable: false,
        value: 'quantity'
    }
]

export default {
    components: {
        InvoiceCard,
        ReturnInfo,
        Comments
    },
    props: {
        invoice: {
            type: Object,
            default: null
        },
        invoiceCardData: {
            type: Object,
            required: true
        },
        productReturn: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            headers
        }
    },
    computed: {
        canEdit: function () {
            return this.productReturn && this.productReturn.status === OPEN
        },
        disableComments: function () {
            return (this.productReturn
                && this.productReturn.status === CLOSED)
                || !UserBus.token
        }
    },
    methods: {
        onBack () {
            this.$emit('back')
        },
        onCreate () {
            this.$emit('create')
        },
        onEditClick () {
            this.$emit('edit')
        },
        onRefreshData () {
            this.$emit('refresh-data', true)
        },
        onConfirmationClick () {
            this.$emit('see-confirmation')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
